export const actionColors = {
  create: '#29CC88',
  update: '#2563eb',
  delete: '#E74032',
};

export const actionLabels = {
  create: 'created',
  update: 'updated',
  delete: 'deleted',
};
